import { createSlice } from "@reduxjs/toolkit";
import initialState from "../initial-state";
import { AppThunk } from "../index";

const soundsOverlay = createSlice({
  name: "soundsOverlay",
  initialState: initialState.soundsOverlay,
  reducers: {
    showSoundOverlay(state) {
      return { ...state, visible: true };
    },
    hideSoundOverlay(state) {
      return { ...state, visible: false };
    },
  },
});

export const { showSoundOverlay, hideSoundOverlay } = soundsOverlay.actions;

export const delayedHideSoundOverlay =
  (delay: number): AppThunk =>
  (dispatch) => {
    setTimeout(() => {
      dispatch(hideSoundOverlay());
    }, delay);
  };

export default soundsOverlay;
